import React, { useEffect } from "react";
import { useQuery } from "@hooks/useQuery";
import { Button, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { Icon } from "@iconify/react";
import UsefullTipPageContent from "./UseFulTipsPageContent/UseFulTipsPageContent";
import UsefullTips from ".";
export const UsefulTipsTab: React.FC = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const items = [
    { label: "Page Content", key: "usefulTipsPageContent", children: <UsefullTipPageContent /> },
    { 
      label: "Page List", 
      key: "usefulTipsPageList", 
      children: <UsefullTips /> 
    },
  ];

  return (
    <>
      <Tabs
        activeKey={query.get('subActiveTab')}
        items={items}
        onChange={(key) => {
          let targetUrl = `${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${key}`;
          navigate(targetUrl);
        }}
      />
    </>
  );
};

export default UsefulTipsTab;
